import { render } from "./ProjectItemName.vue?vue&type=template&id=7e85e9ee"
import script from "./ProjectItemName.vue?vue&type=script&lang=js"
export * from "./ProjectItemName.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__